<template>
  <div class="SinglesDay text-NotoSansLight mx-auto main-bg">
    <nav>
      <div class="py-4 lg:py-6 px-4 lg:px-6 max-w-5xl mx-auto">
        <div class="flex items-center justify-center md:justify-start">
          <router-link :to="{ name: 'index'}" class="flex items-center w-32">
            <img src="~@/assets/images/samsung/pic_liveabc_logo.png" class="object-contain max-w-full w-full">
          </router-link>
        </div>
      </div>
    </nav>
    <div class="main w-full">
      <div class="banner">
        <div class="max-w-5xl mx-auto z-40 flex justify-center items-center px-4">
          <div class="z-40">
            <img src="~@/assets/images/singlesDay2020/Banner.png" class="w-full h-auto max-w-full">
          </div>
        </div>
      </div>
      <div class="award relative z-40 px-4">
        <div class="title absolute w-9/12 max-w-3xl">
          <img src="~@/assets/images/singlesDay2020/title01.png" class="w-full h-auto max-w-full z-40" data-aos="fade-down" data-aos-easing="ease" data-aos-once="true" data-aos-offset="80">
        </div>
        <div class="max-w-5xl mx-auto flex justify-center items-center px-2">
          <div class="">
            <img src="~@/assets/images/singlesDay2020/gift.png" class="w-full h-auto max-w-full">
          </div>
        </div>
      </div>
      <div class="magazine px-2 max-w-5xl mx-auto">
        <div class="max-w-5xl mx-auto flex">
          <div class="livePen py-4">
            <div class="title mb-4 md:mb-6">
              <div class="max-w-5xl mx-auto z-40 flex justify-center items-center px-4">
                <div class="">
                  <img src="~@/assets/images/singlesDay2020/left-light.png" class="w-full z-40 h-auto maw-full"  data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </div>
                <div class="">
                  <img src="~@/assets/images/singlesDay2020/title02.png" class="w-full z-40 h-auto maw-full" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </div>
                <div class="">
                  <img src="~@/assets/images/singlesDay2020/right-light.png" class="w-full z-40 h-auto maw-full" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </div>
              </div>
            </div>
            <div class="flex flex-wrap justify-center">
              <div class="w-1/2 md:w-1/3" v-for="(item, index) in magazine" :key="index">
                <router-link target="_blank" :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }">
                  <img :src="item.img_url" class="object-contain max-w-full mx-auto" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="attention py-12 text-white text-base lg:text-lg">
        <div class="max-w-5xl mx-auto px-4 md:px-8 lg:px-10 tracking-wider relative z-10">
          <div class="w-full leading-relaxed mb-4">
            <h6 class="mb-1">活動時間：</h6>
            <p class="mb-1">2020.11.1 (日) ~ 2020.11.30 (一)</p>
          </div>
          <div class="w-full leading-relaxed mb-4">
            <h6 class="mb-1">抽獎贈品：</h6>
            <p class="mb-1">1.第壹獎 - Galaxy Tab S6 Lite 平板，共1台。</p>
            <p class="mb-1">2.第貳獎 - LiveABC智慧點讀筆16G(L1)，共3支。</p>
          </div>
          <div class="w-full leading-relaxed mb-4">
            <h6 class="mb-1">活動資格：</h6>
            <p class="mb-1">凡於活動期間內，全館單筆訂單消費滿1,111元(包含)以上，即可獲得抽獎機會。</p>
          </div>
          <div class="w-full leading-relaxed mb-4">
            <h6 class="mb-1">得獎公布：</h6>
            <p class="mb-1">將於12月中抽出並於「LiveABC官方網站」及「LiveABC臉書官方粉絲團」公告。</p>
            <p class="text-sm lg:text-base">(領獎時間及領取方式也會一併公告。)</p>
          </div>
          <div class="w-full lg:w-11/12 leading-relaxed mb-4">
            <h6>注意事項：</h6>
            <p class="mb-1">1.訂單經取消、未付款，將視同放棄抽獎資格。</p>
            <P class="mb-1">2.若因通訊資料有誤、或其他相關因素，以致無法聯絡或寄送獎品予得獎者，將視同放棄得獎資格。</P>
            <P class="mb-1">3.參加者保證所有填寫或提出之資料均為真實且正確，且未冒用或盜用任何第三人之資料。如有不實或不正確之情事，將被取消參加或得獎資格。如因此致本公司無法通知其得獎訊息時，LiveABC互動英語教學集團不負任何責任，且如有致損害於本公司或其他任何第三人，參加者應負一切相關責任。</P>
            <P class="mb-1">4.若因登記資料有誤，或因訂單未付款，得獎資格將被取消，恕不另行通知。</P>
          </div>
          <div class="star absolute w-32 md:w-48 lg:w-auto">
            <img src="~@/assets/images/singlesDay2020/star.png" class="object-contain max-w-full z-40" data-aos="zoom-in" data-aos-easing="ease" data-aos-offset="100">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SinglesDay',
  metaInfo () {
    return {
      title: '歡慶雙11購物節',
      titleTemplate: null
    }
  },
  data () {
    return {
      magazine: [
        { name: 'ABC', id: 6968, img_url: require('@/assets/images/singlesDay2020/ORDER-ABC.png') },
        { name: 'ALL', id: 6972, img_url: require('@/assets/images/singlesDay2020/ORDER-ALL.png') },
        { name: 'CNN', id: 6974, img_url: require('@/assets/images/singlesDay2020/ORDER-CNN.png') },
        { name: 'HW', id: 6978, img_url: require('@/assets/images/singlesDay2020/ORDER-HW.png') },
        { name: 'JP', id: 6976, img_url: require('@/assets/images/singlesDay2020/ORDER-JP.png') },
        { name: 'LIVE', id: 6970, img_url: require('@/assets/images/singlesDay2020/ORDER-LIVE.png') }
      ]
    }
  },
  mounted  () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.main-bg {
  background-color: #0e0024;
}
.main {
  background-image: url('~@/assets/images/singlesDay2020/bg.png'), url('~@/assets/images/singlesDay2020/bg-bottom.png');
  background-size: 100% auto;
  background-repeat: no-repeat, no-repeat;
  background-position: 0 top, 0 bottom;
}
.award {
  .title {
    left: 50%;
    transform: translate(-50%, -30%);
  }
}
.attention {
  .star {
    right: 0;
    top: 0;
    z-index: 0;
    @media (max-width: 768px) {
      right: 5%;
      top: 0;
      z-index: 0;
    }
  }
}
</style>
